var render = function render(){var _vm=this,_c=_vm._self._c;return _c('full-screen-dialog',{attrs:{"parameter":"bestaetigungenPDF","value":"true"}},[_c('toolbar',{attrs:{"title":"ADE/DSV/Ärtzl. Attest drucken","show-back":true}}),_c('bestaetigungen-pdf-inhalt',{attrs:{"bestaetigungen":_vm.bestaetigungen,"aktuelle-seite":_vm.aktuelleSeite}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }